import React, { useContext } from 'react';
import { AppContext } from '../context/AppContext';
import './Loader.css';

const Loader = () => {
  const { language } = useContext(AppContext);
  
  return (
    <div className="loader-container">
      <div className="loader-content">
        <div className="loader-logo-wrapper">
          <img 
            src={language === 'ar' ? '/image/logoar.png' : '/image/logofr.png'} 
            alt="Logo DNC" 
            className="loader-logo"
          />
        </div>
        <div className="loader-text">
          {language === 'ar' ? (
            <h2 className="loader-title-ar">المنظومة الوطنية للفرصة الجديدة</h2>
          ) : (
            <h2 className="loader-title-fr">Dispositif National Nouvelle Chance</h2>
          )}
        </div>
        <div className="loader-spinner">
          <div className="spinner-circle"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
